import * as $ from 'jquery';

const settings = {
	quantityInput: '.js-booking-extra-quantity',
}

export const init = () => {
	$(settings.quantityInput).on('change', function (event) {
		const $input = $(this);

		let quantity = 0;
		if ($input.is('input[type="checkbox"]')) {
			if ($input.is(':checked')) {
				quantity = 1;
			}
		} else {
			quantity = $input.val();
		}

		$.ajax('/ajax/booking/update_extras/', {
			method: 'POST',
			data: {
				itemCode: $input.data('api-code'),
				quantity
			},
			success: (response) => {
				const data = JSON.parse(response);

				$(document).trigger('updatePrices', {
					total: data.data.total_price_formatted,
					was: data.data.was ? data.data.was_price_formatted : '',
					deposit: data.data.deposit ? data.data.deposit_price_formatted : ''
				});
			},
			error: (xhr, status, message) => {
				// Show a flash message
				$('#content').prepend(
					'<div class="alert alert-danger alert-dismissible fade show">' +
						'<div class="alert__text">There was a problem updating the optional extras. Please refresh the page and try again</div>' +
						'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button>' +
					'</div>'
				);
			}
		});
	});
}

init();
